import { Skeleton } from '@/common/components/ui/skeleton';

export const SettingsPageSkeleton = () => (
  <div className="space-y-6 pb-10">
    <div className="flex flex-col gap-1">
      <Skeleton className="h-8 max-w-[180px] w-full" />
      <Skeleton className="h-5 max-w-[320px] w-full" />
    </div>
    <div>
      <div className="flex items-center gap-1 border-b border-border">
        <Skeleton className="h-[38px] w-20 rounded-t-sm" />
        <Skeleton className="h-[38px] w-36 rounded-t-sm" />
      </div>
      <div className="pt-6 max-w-4xl space-y-6">
        <Skeleton className="h-[250px] rounded-xl" />
        <Skeleton className="h-[200px] rounded-xl" />
      </div>
    </div>
  </div>
);
